import { Component } from "react";
import "../../../../styles/css/table.scss";
import "../../../../App.css";
import { connect } from "react-redux";
import apis from "../../../../Providers.Api/apis";
import { Link } from "react-router-dom";
import { MDBDataTable } from "mdbreact";
import { handleResDataLength, handleTableSpaceError, multiSort } from "../../../../Common/Helper";
import Spinner from "../../../../Components/Navigation/LoadingSpinner/Spinner"
import {TablePanelInfo} from "../../../../Components/Headings/TableHeading/TablePanelInfo"
import { appContext } from "../../../../AppContext";

class ListUsers extends Component {
  private labels = appContext().labels;
  private local = appContext().localStorageProvider;
  state = {
    isLoadingToGetIdentityProvidersUsers: false,
    isLoadingToGetRightList: false,
    currentPageTitle: this.labels.HubLabelUsers,
    providersNames: { 1: this.labels.HubLabelNative, 2: this.labels.HubLabelAAD, 3: "OKTA" },
    providersDisplayNames: [],
    isCreateRight: false,
  };

  componentDidMount() {
    this.setState({
      isLoadingToGetIdentityProvidersUsers: true,
    })
    sessionStorage.removeItem("roleTitle")
    sessionStorage.removeItem("roleID")
    sessionStorage.removeItem('userID');
    sessionStorage.removeItem('userTitle');
    // sessionStorage.clear();
    apis.getIdentityProvidersUsers().then((res) => {
      for (let j = 0; j < res.data.length; j++) {
        let params = res.data[j];
        let userTypeStatus = "";
        if (params.userType === 0) {
          userTypeStatus = "User"
        }
        if (params.userType === 1) {
          userTypeStatus = "Application"
        }
        let displayNametext = "";
        if (params.displayName === null || params.displayName === "") {
          displayNametext = params.email;
        } else {
          displayNametext = params.displayName;
        }

        res.data[j] = {
          ...res.data[j],
          displayName: displayNametext,
          userType: userTypeStatus,
          clickEvent: () => this.handleClick(params),
          'Option': <button className="btn btn-success" onClick={() => this.handleClick(params)} >Edit </button>
        }
      }
      this.setState({
        isLoadingToGetIdentityProvidersUsers: false,
        providersDisplayNames: res.data,
      })
    }).catch((error: any) => {
      const tableError = handleTableSpaceError(this, error, this.labels.HubLabelTokenErorr);
      this.setState({
        ...tableError
      })
      this.setState({
        isLoadingToGetIdentityProvidersUsers: false,
      })
    });
    this.getRightList();
  }

  getRightList = () => {
    const res = this.local.getIbssRightList();

    if (res.ADMINPORTAL && res.ADMINPORTAL.Users && res.ADMINPORTAL.Users.indexOf("Create") > -1) {
      this.setState({
        isCreateRight: true
      })
    }
  }

  handleClick(params: any) {
    const { history }: any = this.props;
    history.push("security-users/userdetails/" + params.id);
  }

  render() {
    const { providersDisplayNames }: any = this.state;

    const data = {
      columns: [
        {
          label: this.labels.HubLabelName,
          field: "displayName",
          sort: "",
          width: 50
        },
        {
          label: this.labels.HubLabelIdentityprovider,
          field: "identityProviderName",
          sort: "",
          width: 50
        },
        {
          label: this.labels.HubLabelType,
          field: "securityProviderTypeName",
          sort: "",
          width: 50
        },
        {
          label: this.labels.HubLabeluserType,
          field: "userType",
          sort: "",
          width: 50
        },
        {
          label: "",
          field: "",
          sort: "disabled",
        },
      ],
      rows: multiSort(providersDisplayNames, { displayName: 'asc' })
    };

    return (
          <div className="rightPanel-main-content">
            <div className="table-panel">
              <TablePanelInfo
                tableHeading={this.labels.HubLabelUsers}
                iconSrc="User"
              />
              <div className="table-panel-content">
                <Link to="security-users/userdetails/0">
                  {this.state.isCreateRight === false &&
                    <button className="button-primary-disable" disabled={true}>{this.labels.HubButtonNewUser}</button>
                  }
                  {this.state.isCreateRight === true &&
                    <button className="button-primary">{this.labels.HubButtonNewUser}</button>
                  }
                </Link>
              </div>
              <div className="position-relative">
                {(this.state.isLoadingToGetIdentityProvidersUsers || this.state.isLoadingToGetRightList) && <Spinner />}
                <MDBDataTable className="standardTable tablePageNoButtons tableUsers" searchLabel={this.labels.HubLabelMySearchLabel} displayEntries={false} entries={50} hover data={data} />
              </div>
            </div>
          </div>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    currentPageTitle: state.currentPageTitle,
    lightModeTheme: state.lightModeTheme,
    identityProvidersStore: state.identityProviders,
    mainPageTitle: state.mainPageTitle,
  };
};

export default connect(mapStateToProps)(ListUsers);
function params(params: any): void {
  throw new Error("Function not implemented.");
}

